import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { Campaign3BreadcrumbComponent } from 'app/views/campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';
import { Campaign3TestService } from 'app/views/campaign-3/services/campaign3testservice';
import { ActionStateService } from 'app/views/campaign-3/services/actionstate.service';
import { ChallengeService } from '../challenge.service';
import { ChallengeResponse } from '../challenge.model';
import { ScheduleResponse } from 'app/views/notification/model/notification-model';
import { NotificationService } from 'app/views/notification/services/notification-service.service';





@Component({
    selector: 'app-challenge-list',
    templateUrl: './challenge-list.component.html',
    styleUrls: ['./challenge-list.component.css']
})
export class ChallengeListComponent implements OnInit {
    /* ----------------------------- ViewChild ----------------------------- */
    @ViewChild('breadcrumbComponent') breadcrumb: Campaign3BreadcrumbComponent;
    @ViewChild('challengeList') kontableComponent: Campaign3KontableComponent;

    /* ----------------------------- UI State ------------------------------ */
    showPopupEdit = false;
    showPopupCreate = false;
    displayDeleteDialog = false;
    showMenu = false;
    showBreadCrumb = false;
    readyTable = false;
    showPopupPublish: boolean = false;
    showPopupUnpublish: boolean = false;

    currentOpenedRow: number = null;

    //notification
    showNotificationStatusModal = false;
selectedNotificationRow: ScheduleResponse = null;
isLoadingNotification = false;

    /* -------------------------- Filters & Table -------------------------- */
    paginationType = KontableComponent.ServerPagination;
    dateFilter = KontableComponent.DateFilter;
    numberFilter = KontableComponent.NumberFilter;
    textFilter = KontableComponent.TextFilter;
    selectFilter = KontableComponent.SelectFilter;
    noFilter = KontableComponent.NoFilter;

    pageSubject = 'distribution-list';

    startDate: Date = null;
    endDate: Date = null;

    /* ------------------------------ Data -------------------------------- */
    breadcrumbs: BreadCrumbModel[] = [];
    challengeTypes: Array<{ label: string; value: string }> = [];
    statusList: Array<{ label: string; value: string }> = [];
    statusLabels: { [key: string]: string } = {};
    challengeToDelete: ChallengeResponse = null;

    /* ---------------------------- Field Model ---------------------------- */
    fieldModel = {
        campaign_name: 'campaign_name',
        campaign_description: 'campaign_description',
        start_date: 'start_date',
        end_date: 'end_date',
        budget_type: 'budget_type',
        budget_value: 'budget_value',
        campaign_type: 'campaign_type'
    };

    /* --------------------------- Status Colors --------------------------- */
    statusColors = {
        0: 'green-dot',
        1: 'orange-dot',
        2: 'green-dot',
        3: 'green-dot',
        4: 'red-dot'
    };

    constructor(
        public testService: Campaign3TestService,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public srvCalendar: CalendarTranslateService,
        public actionStateService: ActionStateService,
        private srvNotify: MessageService,
        private translate: TranslateService,
        private challengeService: ChallengeService,
        private route: ActivatedRoute,
        private notificationService: NotificationService
    ) { }
    /* ---------------------------- Lifecycle ------------------------------ */
    challengeIdFromRoute: number | null = null;

    ngOnInit(): void {
        // Recupero parametri da URL
        this.route.queryParams.subscribe(params => {
            const id = params['challengeId'];
            if (id) {
                this.challengeIdFromRoute = Number(id);
            }
        });

        // Inizializzazione componente
        this.initializeComponent();
    }

    applyInitialIdFilter(id: number) {
        const table = this.kontableComponent;
        if (table) {
            // Applico il filtro
            table.filter.search = [{ key: 'id', value: String(id) }];
            table.updateTableFilter(null, null, null, 1, 1000, true);

            // Pulisco la ricerca
            table.filter.search = [];

            // Rimuovo il parametro dall'URL
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { challengeId: null },
                queryParamsHandling: 'merge',
                replaceUrl: true
            });
        }
    }


    /* --------------------------- Initialization -------------------------- */
    private initializeComponent(): void {
        var CHALLENGE_LIST = this.translate.get('challenge.challenge-list');
        var STATUS_ACTIVE = this.translate.get('challenge.active');
        var STATUS_CANCELLED = this.translate.get('challenge.cancelled');
        var STATUS_DRAFT = this.translate.get('challenge.draft');
        var STATUS_PREVIEW = this.translate.get('challenge.preview');
        var STATUS_UNKNOWN = this.translate.get('challenge.unknown');
        var PUBLICATION_CANCELED = this.translate.get('challenge.publicationCanceled');


        var CHALLENGE_TYPES = this.challengeService.getChallengeTypeList();

        Observable.zip(
            CHALLENGE_LIST,
            STATUS_ACTIVE,
            STATUS_CANCELLED,
            STATUS_DRAFT,
            STATUS_PREVIEW,
            STATUS_UNKNOWN,
            PUBLICATION_CANCELED,
            CHALLENGE_TYPES
        ).subscribe(([
            challengeList,
            statusActive,
            statusCancelled,
            statusDraft,
            statusPreview,
            statusUnknown,
            statusPublicationCanceled,
            typeList
        ]) => {

            this.breadcrumbs = [
                { code: 'bc1', description: challengeList, routerLink: '/challenge-list' }
            ];

            this.statusLabels = {
                '0': statusActive,
                '1': statusCancelled,
                '2': statusDraft,
                '3': statusPreview,
                '4': statusPublicationCanceled,
                'default': statusUnknown
            };

            /* ----- Status per filtro ----- */
            this.statusList = [{ label: '', value: null }];
            var keys = Object.keys(this.statusLabels);

            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (key !== 'default') {
                    this.statusList.push({
                        label: this.statusLabels[key],
                        value: key
                    });
                }
            }

            /* ----- Challenge Types ----- */
            this.challengeTypes = [{ label: '', value: null }];

            if (typeList && typeList.length > 0) {
                for (var t = 0; t < typeList.length; t++) {
                    var type = typeList[t];
                    this.challengeTypes.push({
                        label: type.description,
                        value: String(type.id)
                    });
                }
            }
            this.showBreadCrumb = true;

            this.readyTable = true;
            setTimeout(() => {
                if (this.challengeIdFromRoute) {
                    this.applyInitialIdFilter(this.challengeIdFromRoute), 200
                }
            });


        });
    }

    /* ------------------------------ Helpers ------------------------------ */
    clearDateFields(): void {
        this.startDate = null;
        this.endDate = null;
    }

    getStatusLabel(status: any): string {
        var map = {
            '0': 'Attiva',
            '1': 'Annullata',
            '2': 'Bozza',
            '3': 'In preview'
        };

        if (map[status] !== undefined) {
            return map[status];
        }
        return 'Sconosciuto';
    }

    /* ----------------------------- Navigation ---------------------------- */
    onOpenCreation(): void {
        this.router.navigate(['/challenge-creation']);
    }

    onOpenEdit(row: any): void {
        this.router.navigate(['/challenge-creation'], {
            queryParams: { challengeId: row.id }
        });
    }
 /*    goToGraphics(row: any):void{
          this.router.navigate(['/challenge-graphics'], {
            queryParams: { challengeId: row.id }
        });
    } */

    /* ------------------------------ Menu -------------------------------- */
    toggleMenu(row: ChallengeResponse): void {
        var id = row.id;

        if (this.showMenu && this.currentOpenedRow !== id) {
            this.showMenu = false;
        }

        this.currentOpenedRow = id;
        this.showMenu = !this.showMenu;
    }

    @HostListener('document:click', ['$event'])
    onClick(event: any): void {
        var target = event.target;

        if (
            (!target.closest || !target.closest('.dropdown-menu')) &&
            (!target.closest || !target.closest('.d-flex'))
        ) {
            this.showMenu = false;
        }
    }

    /* --------------------------- Table Actions --------------------------- */
    refreshAfterEdit(): void {
        this.kontableComponent.refresh();
    }

    onCheckEndDistribution(row: any): boolean {
        return (
            (row.end_date && new Date(row.end_date) < new Date()) ||
            row.flg_state === '1'
        );
    }

    isRowEditable(row: any): boolean {
        if (!row) {
            return false;
        }
        return row.status !== '1' && row.status !== 1;
    }

    refreshChallengeLevelsViaKontable(row: any): void {
        this.kontableComponent.fetchChallengeList(row);
    }

    /* --------------------------- Delete Logic ---------------------------- */
    deleteChallenge(row: ChallengeResponse): void {
        this.challengeToDelete = row;
        this.displayDeleteDialog = true;
    }

    closePopupDelete(): void {
        this.displayDeleteDialog = false;
    }

    onDefinitiveDelete(row: ChallengeResponse): void {
        this.challengeService.deleteChallenge(row.id).subscribe({
            next: () => {
                this.displayDeleteDialog = false;

                this.srvNotify.add({
                    severity: 'success',
                    summary: this.translate.instant('common.success'),
                    detail: this.translate.instant('challenge.delete_success'),
                    life: 5000
                });

                this.kontableComponent.refresh();
            },
            error: (err) => {
                console.error('Errore durante la cancellazione challenge:', err);

                this.srvNotify.add({
                    severity: 'error',
                    summary: this.translate.instant('common.error'),
                    detail: this.translate.instant('challenge.delete_error'),
                    life: 5000
                });
            }
        });
    }

    /* --------------------------- Publish Logic ---------------------------- */
    // Tipo generico per la challenge
    challengeToPublish: ChallengeResponse;
    // ---------- PUBLISH ----------
    publishChallenge(row: ChallengeResponse): void {
        console.log('Apertura popup pubblicazione', row);
        this.challengeToPublish = row;
        this.showPopupPublish = true;
    }

    undoPublishChallenge(): void {
        this.showPopupPublish = false;
    }

    confirmPublish(): void {
    const id = this.challengeToPublish && this.challengeToPublish.id;
    if (!id) {
        console.error('ID challenge non valido per pubblicazione');
        return;
    }

    console.log('Conferma pubblicazione challenge id:', id);

    this.challengeService.publishChallenge(id).subscribe({
        next: () => {
            this.showPopupPublish = false;

            this.srvNotify.add({
                severity: 'success',
                summary: this.translate.instant('common.success'),
                detail: this.translate.instant('challenge.publish_challenge_success'),
                life: 5000
            });
            this.kontableComponent.refresh();
        },
        error: (err) => {
            console.error('Errore durante la pubblicazione challenge:', err);

            this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('challenge.publish_challenge_error'),
                life: 5000
            });
        }
    });
}

    challengeToUnpublish: ChallengeResponse;

    // ---------- UNPUBLISH ----------
    unpublishChallenge(row: ChallengeResponse): void {
        console.log('Apertura popup annulla pubblicazione', row);
        this.challengeToUnpublish = row; // usa stessa variabile se vuoi
        this.showPopupUnpublish = true;
    }

    undoUnpublishChallenge(): void {
        this.showPopupUnpublish = false;
    }

    confirmUnpublish(): void {
    const id = this.challengeToUnpublish && this.challengeToUnpublish.id;
    if (!id) {
        console.error('ID challenge non valido per unpublish');
        return;
    }

    console.log('Conferma annullamento pubblicazione challenge id:', id);

    this.challengeService.undoPublishChallenge(id).subscribe({
        next: () => {
            this.showPopupUnpublish = false;

            this.srvNotify.add({
                severity: 'success',
                summary: this.translate.instant('common.success'),
                detail: this.translate.instant('challenge.unpublish_challenge_success'),
                life: 5000
            });
            this.kontableComponent.refresh();

        },
        error: (err) => {
            console.error('Errore durante annullamento pubblicazione challenge:', err);

            this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('challenge.unpublish_error'),
                life: 5000
            });
        }
    });
}

    // ---------- UTILITY ----------
    isAlreadyDeleted(row: ChallengeResponse): boolean {
        // TODO: implementare logica reale
        return false;
    }

  canPublish(row: ChallengeResponse): boolean {
    let result = true;

    if (row == null) {
        result = false;
    } else if (row.status === '0') {
        result = false;
    }

    return result;
}
canUnpublish(row: ChallengeResponse): boolean {
    let result = true;

    if (row == null) {
        result = false;
    } else if (row.status !== '0') {
        result = false;
    }

    return result;
}


    isEditable(row: ChallengeResponse) {
        return true;
    }




    openNotificationStatus(row: any): void {
    this.isLoadingNotification = true;
    this.notificationService.getNotificationDetail(row.id).subscribe({
        next: (detail) => {
            this.selectedNotificationRow = detail;
            this.showNotificationStatusModal = true;
            this.isLoadingNotification = false;
        },
        error: (err) => {
            console.error('Errore caricamento stato notifica:', err);
            this.isLoadingNotification = false;
            this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('notification.load_error'),
                life: 5000
            });
        }
    });
}

closeNotificationStatusModal(): void {
    this.showNotificationStatusModal = false;
    this.selectedNotificationRow = null;
}





}





// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge-list/challenge-list.component.ts